import React from 'react';
import { mockData } from './data';
import { CalendarIcon, TargetIcon, StarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface TrackerProps {
  icon: React.ReactNode;
  title: string;
  caption: string;
  current: number;
  required: number;
  unit: string;
  remainingLabel: string;
  delay?: number;
}
function Tracker({
  icon,
  title,
  caption,
  current,
  required,
  unit,
  remainingLabel,
  delay = 0
}: TrackerProps) {
  const pct = current / required * 100;
  return <div data-id="element-269">
      <div className="flex items-center gap-3 mb-3" data-id="element-270">
        <div className="bg-blue-50 p-2 rounded-lg text-[#2563EB] shrink-0" data-id="element-271">
          {icon}
        </div>
        <div data-id="element-272">
          <h3 className="text-sm font-bold text-[#0A1F5C] uppercase tracking-wide" data-id="element-273">
            {title}
          </h3>
          <p className="text-xs text-gray-500 font-medium" data-id="element-274">{caption}</p>
        </div>
      </div>

      <div className="flex justify-between items-baseline mb-2" data-id="element-275">
        <span className="text-2xl font-bold text-[#0A1F5C] tabular-nums" data-id="element-276">
          {current}{' '}
          <span className="text-sm text-gray-500 font-semibold" data-id="element-277">
            / {required} {unit}
          </span>
        </span>
        <span className="text-[10px] font-bold text-[#2563EB] uppercase tracking-wider" data-id="element-278">
          {remainingLabel}
        </span>
      </div>

      <div className="h-2.5 w-full bg-gray-100 rounded-full overflow-hidden" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100} data-id="element-279">
        <motion.div initial={{
        width: 0
      }} animate={{
        width: `${pct}%`
      }} transition={{
        duration: 1,
        delay,
        ease: 'easeOut'
      }} className="h-full bg-[#2563EB] rounded-full" data-id="element-280" />
      </div>
    </div>;
}
export function PathToSeniorProcessor() {
  const {
    tenure,
    performance
  } = mockData.advancement;
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay: 0.5
  }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden h-full flex flex-col" data-id="element-281">
      <div className="bg-[#0A1F5C] text-white px-5 py-4 flex items-center gap-3" data-id="element-282">
        <div className="bg-white/15 p-1.5 rounded-full" data-id="element-283">
          <StarIcon className="w-4 h-4" data-id="element-284" />
        </div>
        <h2 className="text-base font-bold tracking-wide uppercase" data-id="element-285">
          Your Path to Senior Processor
        </h2>
      </div>

      <div className="p-6 flex-1 flex flex-col gap-7" data-id="element-286">
        <Tracker icon={<CalendarIcon className="w-5 h-5" data-id="element-288" />} title="18 Months" caption="Minimum of 18 months as a Loan Processor" current={tenure.current} required={tenure.required} unit="mo" remainingLabel={`${tenure.required - tenure.current} months to go`} delay={0.8} data-id="element-287" />

        <Tracker icon={<TargetIcon className="w-5 h-5" data-id="element-290" />} title="Performance Requirement" caption="Close 90 loans in any 6-month period" current={performance.current} required={performance.required} unit="loans" remainingLabel={`${performance.required - performance.current} loans to go`} delay={1} data-id="element-289" />

        <div className="mt-auto pt-2" data-id="element-291">
          <div className="flex items-start gap-3 bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-292">
            <StarIcon className="w-5 h-5 text-[#0A1F5C] shrink-0 mt-0.5 fill-[#0A1F5C]" data-id="element-293" />
            <p className="text-xs text-gray-700 leading-relaxed" data-id="element-294">
              <span className="font-bold text-[#0A1F5C] uppercase tracking-wider mr-1" data-id="element-295">
                Experienced Professionals:
              </span>
              New hires with major processing experience may qualify for the
              Senior Processor tier immediately, case by case.
            </p>
          </div>
        </div>
      </div>
    </motion.section>;
}